export default {
  event: {},
  training: {},
  ceo: {},
  trainingGuests: [],
  companyGuests: [],
};
